module.exports = __webpack_public_path__ + "img/06.5e7115ca.png";